import { computed, type ComputedRef } from 'vue';
import { storeToRefs } from 'pinia';
import { useConfig } from '@/stores/useConfig';

/**
 * Central composable for header visibility, mirroring the logic in pl-chat-sdk CommonPage.vue.
 *
 * Priority rules (highest first):
 * 1. If `uiConfig.header.show === false` (explicit false) → HIDE header on all pages.
 * 2. Otherwise → fall back to the provided `customisationFallback` value
 *    (derived from brand customisation set in the Admin Console).
 *
 * @param customisationFallback - The `isVisible` ref returned by the page-specific
 *   customisation composable (e.g. useHomeHeaderCustomisation, useConversationsHeaderCustomisation).
 * @returns A computed boolean ref representing the final header visibility decision.
 */
export const useHeaderVisibility = (customisationFallback: ComputedRef<boolean>) => {
  const { config } = storeToRefs(useConfig());

  return computed(() => {
    if (config.value?.uiConfig?.header?.show === false) {
      return false;
    }
    return customisationFallback.value;
  });
};
